import React, { useState } from "react";
import Image from "next/image";
import HealthcareGlobalForm from "@/components/forms/HealthcareGlobalForm";
import {
  MilesHealthcareSubCategory,
  HealthcareFormHeading,
  VerticalCategory,
} from "@/interface/types";
import useModalScrollLock from "@/hooks/useModalScrollLock";

const DoctorNeetMobile = () => {
  const [isPopupOpen, setPopupOpen] = useState({ open: false, code: "" });
  const [isFormModelOpen, setIsFormModelOpen] = useState<boolean>(false);

  const openPopup = (code: string) => {
    setPopupOpen({ open: true, code: code });
  };

  const closePopup = () => {
    setPopupOpen({ open: false, code: "" });
  };

  const handleFormModelOpen = () => {
    setIsFormModelOpen(true);
  };

  const handleFormModelClose = () => {
    setIsFormModelOpen(false);
  };

  useModalScrollLock(isFormModelOpen || isPopupOpen.open, {
    restoreScrollPosition: true,
    preventTouchScroll: true,
  });

  return (
    <>
      <div className="bg-[#061A2F] w-full pt-8 relative">
        <Image
          src="/cpa/visit/newVisit/alu_l1.png"
          alt="Special Offer"
          className=" mx-auto absolute left-0 top-0 z-0 "
          width={300}
          height={233}
          priority
        />

        <div className="lg:container mx-auto h-full 2xl:px-0 xl:px-12 lg:px-6 px_5 relative z-20">
          <div className="text-center">
            <h2 className="text-2xl xl:text-[64px] md:text-[32px] text-[28px] mb-3 font-semibold lg:leading-[3.5rem] md:leading-[3rem] leading-[1.8rem] text-white text-center inline-block mx-auto px-[4px]">
              NEET to Doctor in{" "}
              <span className="md:pb-0 bg-[linear-gradient(96deg,#39f_8.49%,#ffba08_87.26%)] bg-clip-text text-transparent [-webkit-text-fill-color:transparent] inline-block pr-[5px] italic">
                USA
              </span>
            </h2>
            <p className="text-white font-medium text-[18px] leading-[1.3] tracking-[-0.64px] text-center">
              Your Pathway to a Global Medical Career
            </p>
          </div>
          <div
            className="w-[100%] mt-6"
            onClick={() => {
              openPopup("ATVuwnrm9Y4");
            }}
          >
            <Image
              src="/healthcare/doctors/new-mob/doc-neet.png"
              alt="neet"
              className="cursor-pointer rounded-[8px] w-full px-6"
              width={200}
              height={169}
            />
          </div>
          <div className="text-center pt-4 pb-4">
            <button
              className="bg-[#1772ea] rounded-[12px_12px_12px_0px] text-white px-14 mx-auto text-[14px] w-[249px] py-[11px] font-semibold"
              onClick={handleFormModelOpen}
            >
              Apply Now
            </button>
          </div>
        </div>
        {isPopupOpen.open && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-1 shadow-lg relative rounded-[14px] md:w-[auto] w-[85%]">
              <button
                onClick={closePopup}
                className="mt-4 bg-red-700 text-white px-3 py-1 rounded absolute right-[-15px] top-[-30px]"
              >
                ✕
              </button>
              <iframe
                className="lg:w-[600px] md:w-[500px] md:h-[280px] rounded-[14px] lg:h-[320px] h-[220px]"
                width="100%"
                id="huge-shortage-video-player"
                height="320"
                src={`https://www.youtube.com/embed/${isPopupOpen.code}`}
                title="YouTube video player"
                allow="accelerometer; autoplay; climd:oard- pb-14write; encrypted-media; gyroscope; picture-in-picture; web-share"
              ></iframe>
            </div>
          </div>
        )}
      </div>
      {isFormModelOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[999] lg:p-10 p-1">
          <div className="rounded-[14px] shadow-lg relative lg:w-[450px] lg:h-[auto] md:w-[450px] h-[auto] mx-auto w-[365px] bg-[#061A2F] lg:py-0 lg:px-0 p-0">
            <button
              onClick={handleFormModelClose}
              className="px-3 text-[12px] py-1 rounded absolute md:right-[10px] right-1 top-[1px] z-[9999] text-lg text-white"
            >
              ✕
            </button>
            <div className="h-auto relative border-2 rounded-2xl border-white p-2">
              <Image
                priority
                src="/healthcare/doctors/st.png"
                alt="arrow image"
                className="absolute left-[32px] top-5 right-1"
                width={32}
                height={32}
              />
              <HealthcareGlobalForm
                formType="page"
                verticalCategory={VerticalCategory.HEALTHCARE}
                subCategory={MilesHealthcareSubCategory.DOCTORS}
                submitButtonName="Enroll Now"
                courseId={33}
                formHeading={HealthcareFormHeading.DOCTORS_PAGE_BOTTOM}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DoctorNeetMobile;
